module.exports = __webpack_public_path__ + "static/media/cover.bda5885f.png";